import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../assets/i18n";
import "./PriceTagPage.scss";
import { ButtonStandard, TagMarker, HeaderActions, FooterActions, ToastMessage } from "../../components";
import ItemList from "../../containers/ItemList/ItemList";
import getMessageError from "../../utils/getMessageError";
import { Creators as actionTag } from "../../store/ducks/tag";
import { Creators as actionPrinter } from "../../store/ducks/printer";
import { COMPANIES, TAGTYPES } from '../../utils/constants';

function PriceTagPage(props) {
    
    const CAMICADO = 3; 
    const YOUCOM = 4;

    const dispatch = useDispatch();

    const lang = useSelector(state => state.language.name);
    const itemList = useSelector(state => state.itemList.items);
    const orderList = useSelector(state => state.orderList);
    const tag = useSelector(state => state.tag);
    const printer = useSelector(state => state.printer);

    const tagToast = useSelector(state => state.tag.tagToast);

    const [checkBoxesSelected, setCheckBoxesSelected] = useState([]);
    const [option, setOption] = useState('download');
    const [objQtCompra, setObjQtCompra] = useState([]);

    const [customTagOptions, setCustomTagOptions] = useState({
        tipo: TAGTYPES.ZEBRA.NAME
    }); 

    const [showToast,    setShowToast]    = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');

    useEffect(() => {	
        setShowToast(tagToast.showToast)
        setToastMessage(tagToast.message)
        setMessageType(tagToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tagToast]);

    useEffect(() => {
        if(orderList[0] !== undefined){
            dispatch({ 
                type: 'GET_ITEMS', 
                pedido: orderList[0].id
            })
        }
    }, [orderList, dispatch])

    useEffect(() => {
        let objQtCompra = {};

        if(itemList.length) {
            for (let i = 0; i < itemList.length; i++) {
                objQtCompra[itemList[i].id] = {
                    qtCompra: itemList[i].qtCompra,
                    qtCompraMax: itemList[i].qtCompra,
                }
            }
        }
        setCheckBoxesSelected(toggleAllArrChecked(itemList, checkBoxesSelected));
        setObjQtCompra(objQtCompra);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemList])

    useEffect(() => {
        dispatch(actionTag.tagsClean());
        dispatch(actionPrinter.printerWriteClean());
    }, [dispatch])

    useEffect(() => {
        if (tag.error) {
            setShowToast(true)
            setToastMessage(messages[lang].messagesCode[getMessageError(tag.error)])
            dispatch(actionTag.tagsClean());
        }
    }, [tag.error, lang, dispatch])
    
    useEffect(() => {
        if (printer.error) {
            setShowToast(true)
            setToastMessage(messages[lang].messagesCode[getMessageError(printer.error)])
            dispatch(actionPrinter.printerWriteClean());
        }
    }, [printer.error, lang, dispatch])

    const getTag = (tipoTag, tipoDeRetorno, pedido, itens) => {
        dispatch({
            type: "GET_TAG",
            payload: {
                tipoTag: tipoTag,
                tipoDeRetorno: tipoDeRetorno,
                pedido: pedido,
                itens: itens,
                nomeArquivoPdf: messages[lang].priceTagPdf,
                customOptions: orderList[0].empresa.id === COMPANIES.RENNER.ID ? customTagOptions : false
            }
        })
    }

    const outputOptionHandler = (optionChecked) => {
        optionChecked === '0'
            ? setOption('download') 
            : optionChecked === '1'
                ? setOption('print')
                : setOption('generatePDF');
    }

    const enableDownload = () => {
        return true;
    }

    const enablePrint = () => {
        if (orderList[0].empresa.id === COMPANIES.RENNER.ID && customTagOptions.tipo === TAGTYPES.TXT.NAME) {
            return false
        }
        if (orderList[0] && parseInt(orderList[0].empresa.id) === YOUCOM && orderList[0].naturezaPedido.toLowerCase() === "importado") {
            return false;
        }
        if (orderList[0] && parseInt(orderList[0].empresa.id) === CAMICADO && orderList[0].naturezaPedido.toLowerCase() === "normal"){
            return false;
        }
        return true;
    }

    const setTagType = (options, tagType) => {
        setCustomTagOptions(options)
        setOption('download')
    }

    const enablePdf = () => {
        return (orderList[0] && parseInt(orderList[0].empresa.id) === CAMICADO && orderList[0].naturezaPedido.toLowerCase() === "importado")
            ? true
            : false;
    }

    const listSelectedItems = (arrChecked) => {
        return arrChecked.map(idChecked => {
            const itemSelected = itemList.find(item => item.id === idChecked);
            if (itemSelected) {
                return {
                    idItem: itemSelected.id,
                    qtItem: getObjQtCompra(itemSelected.id)
                };
            } else {
                return {};
            }
        });
    }

    const onChangeInputValue = idItem => event => {
        let newValue = event.target.value.replace(/[^0-9]+/g, "");
        newValue = newValue && parseInt( newValue , 10);
        setObjQtCompra({ 
            ...objQtCompra, 
            [idItem]: {
                qtCompra: newValue > objQtCompra[idItem].qtCompraMax ? objQtCompra[idItem].qtCompraMax : newValue,
                qtCompraMax: objQtCompra[idItem].qtCompraMax,
            }
        });
    }

    const getObjQtCompra = idValue => (
        objQtCompra && objQtCompra[idValue] ? objQtCompra[idValue].qtCompra : ''
    )

    const disable = () => {
        let status = checkBoxesSelected.map((value) => {
            if (value !== null) {
               if ((value.idItem === null)) {return "neutro"}
               else if (!(value.idItem === null) && !(value.qtItem === "")) {return "habilitado"}
               else return "desabilitado"
            } else return "neutro"
        })
        if (status.every((value) => value === "neutro")) {return true} 
        else if(status.find((value) => value === "desabilitado")) {return true}
        else return false
    }

    const pageBack = () => {
        dispatch({ type: "ITEM_CLEAN" })
		props.history.push(`/main`);
    };

    const handleAllCheckBoxesSelected = () => {
        setCheckBoxesSelected(toggleAllArrChecked(itemList, checkBoxesSelected))
    }

    const toggleAllArrChecked = (listItems, checkboxArr) => (
        checkboxArr && listItems.length && checkboxArr.length < listItems.length ? listItems.map(item => item.id) : []
    )

    const buttonAction = () => <ButtonStandard
        id="price-tag-label_button"
        text={messages[lang][option]}
        textClass="text-2"
        className="btn btn-primary px-3 py-2 btn-light"
        onClick={() => getTag("gerar", option, orderList[0].id, listSelectedItems(checkBoxesSelected))}
        disabled={disable()}
        isLoading={tag.loading}
    />

    const headers = [
        {
            checkbox: {
                arrChecked: checkBoxesSelected,
                handleAllArrChecked: handleAllCheckBoxesSelected,
            }
        },
        messages[lang].labelItem,
        messages[lang].product,
        messages[lang].labelTotalItems,
        messages[lang].totalPriceTag,
    ];

    const tableList = itemList && itemList.map(item => {
        return [
            {
                checkbox: {
                    id: item.id,
                    arrChecked: checkBoxesSelected, 
                    setArrChecked: setCheckBoxesSelected,
                }
            },
            item.codItem,
            {
                text: item.detalheItems && item.detalheItems[0] ? item.detalheItems[0].descricaoCurta : '',
                maxLength: 300,
                tooltip: item.detalheItems && item.detalheItems[0] ? item.detalheItems[0].descricaoCurta : '',
            },
            item.qtCompra,
            {
                text: <input size={15} className="text-1" id={"qtCompra_" + item.id} 
                        onChange={onChangeInputValue(item.id)} 
                        value={getObjQtCompra(item.id)} />
            }
        ]
    });

    const companyOptions = [
        { id: TAGTYPES.ZEBRA.NAME, message: TAGTYPES.ZEBRA.NAME },
        { id: TAGTYPES.TXT.NAME, message: TAGTYPES.TXT.NAME },
    ];

    return (
        <div className="price-tag-page">
            <iframe title="myFrame" id="ifmcontentstoprint" style={{height: 0, width: 0, position: "absolute"}}></iframe>

            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={toastMessage} 
                toastClass={messageType} />

            <HeaderActions
                titlePage={messages[lang].priceTag} 
                pageBack={pageBack} 
            />

            <Container className="mt-2">
                <Row className="justify-content-center">
                    {
                        orderList[0].empresa.id === COMPANIES.RENNER.ID 
                        ?
                        <Col>
                            <Col>
                                <Container className="py-1">
                                    <Row className="justify-content-center">
                                        <p className="text-3 text-color-black font-weight-bolder my-0 pt-1">
                                            {messages[lang].priceTagTypes.type}
                                        </p>
                                    </Row>
                                </Container>

                                <Form.Control
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={customTagOptions.tipo || ''}
                                    disabled={false}
                                    onChange={event => setTagType(
                                        { ...customTagOptions, tipo: event.target.value },
                                    )}
                                >
                                    {
                                        companyOptions.map(value => (
                                            <option key={value.message} value={value.id}>{value.message}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Col>
                        </Col>
                        :
                        null
                    }

                    <Col>
                        <TagMarker 
                            onClick={outputOptionHandler}
                            enableDownload={enableDownload()}
                            enablePrint={enablePrint()}
                            enablePdf={enablePdf()}
                        />
                    </Col>
                </Row>
            </Container>

            <Container className="mt-2 pt-3 mb-5 pb-5">
                <ItemList header={headers} titleTable={messages[lang].priceTag} listTable={tableList} />
            </Container>

            <FooterActions ButtonGroupRight={buttonAction} />

        </div>
    )
}

export default withRouter(PriceTagPage); 